import OjtAudit from './src/main';

OjtAudit.install = function(Vue) {
  Vue.component(OjtAudit.name, OjtAudit);
};

export default OjtAudit;
